import { z } from "zod/v4";

export const CreateExclusionGroupEntityDtoSchema = z.object({
  id: z
    .uuid()
    .optional()
    .describe("Unique identifier for the exclusion group entity"),
  experienceId: z
    .uuid()
    .describe("Experience ID that is part of this exclusion group"),
  percentage: z
    .number()
    .describe(
      "Percentage of traffic allocated to this experience within the group"
    ),
  order: z.number().describe("Order of priority within the exclusion group"),
  hasPriorityOrder: z
    .boolean()
    .default(false)
    .describe("Whether this entity has priority ordering enabled"),
});
export type CreateExclusionGroupEntityDto = z.infer<
  typeof CreateExclusionGroupEntityDtoSchema
>;

export type ExclusionGroupEntityDto = z.infer<
  typeof ExclusionGroupEntityDtoSchema
>;

// on creation of new exclusion group
export const CreateExclusionGroupDtoSchema = z.object({
  id: z.uuid().optional().describe("Unique identifier for the exclusion group"),
  name: z.string().describe("Name for the mutual exclusion group"),
  exclusionGroupEntities: CreateExclusionGroupEntityDtoSchema.array()
    .default([])
    .describe("Experiences that are mutually exclusive (users see only one)"),
  reassignOnEnd: z
    .boolean()
    .default(false)
    .describe("Whether to reassign users to other experiences when one ends"),
  hasWeightedValues: z
    .boolean()
    .default(false)
    .describe("Whether to use weighted distribution across experiences"),
});

export type CreateExclusionGroupDto = z.infer<
  typeof CreateExclusionGroupDtoSchema
>;

// full exclusion entity with no optional IDs
export const ExclusionGroupEntityDtoSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    id: z.uuid(),
    experienceId: z.uuid(),
  });

export const ExclusionGroupDtoSchema = CreateExclusionGroupDtoSchema.extend({
  id: z.uuid(),
});

export type ExclusionGroupDto = z.infer<typeof ExclusionGroupDtoSchema>;

export const CreateExclusionGroupEntityOnCreateSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    experienceId: z
      .uuid()
      .optional()
      .describe("Experience ID (optional when creating with experience)"),
  });

export const CreateExclusionGroupOnCreateSchema =
  CreateExclusionGroupDtoSchema.extend({
    exclusionGroupEntities: CreateExclusionGroupEntityOnCreateSchema.array()
      .default([])
      .describe(
        "Array of experiences and their traffic allocations within the exclusion group"
      ),
  });

export type CreateExclusionGroupOnCreate = z.infer<
  typeof CreateExclusionGroupOnCreateSchema
>;
